<template>
    <v-container
        fluid
    >
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">File Management</v-col>
                    </v-row>
                </v-alert>
            </v-col>
            
            <v-col
                cols="12"
            >
                <v-btn
                    text
                    @click="AddNew"
                >
                    <v-icon class="mr-2">mdi-plus</v-icon>Add New File
                </v-btn>
            </v-col>

            <v-col
                cols="12"
            >
                <v-data-table
                    :headers="filerepos.headers"
                    :items="filerepos.items"
                    :options.sync="options"
                    :server-items-length="filerepos.total"
                    :loading="filerepos.loading"
                    class="elevation-6"
                    fixed-header
                >
                    <template v-slot:item.actions="{ item }">
                        <v-btn
                            text
                            @click="Download(item)"
                        >
                            <v-icon class="mr-2">mdi-cloud-download-outline</v-icon>
                        </v-btn>

                        <v-btn
                            text
                            @click="Edit(item)"
                        >
                            <v-icon class="mr-2">mdi-lead-pencil</v-icon>
                        </v-btn>

                        <v-btn
                            text
                            @click="Delete(item)"
                        >
                            <v-icon class="mr-2">mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-snackbar
            v-model="showSnackbar"
            :color="snackbarVariant"
            :timeout="3000"
            :top="'top'"
            absolute
            centered
            elevation="24"
            style="z-index: 9999"
        >
            <v-layout color="transparent" dark>{{ modalMessage }}</v-layout>
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="showSnackbar = false"
                >
                    <i class="mdi mdi-close"></i>
                </v-btn>
            </template>
        </v-snackbar>

        <v-overlay :value="overlay" style="z-index: 2000;">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog
            v-model="filerepoform"
            scrollable
            max-width="640"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-document-edit-outline mr-2"></i>File Details</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-row dense>
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                label="File Name"
                                v-model="filerepo.filename"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-textarea
                                outlined
                                label="Description"
                                v-model="filerepo.description"
                            ></v-textarea>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-if="dropzoneexposed"></vue-dropzone>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        dark
                        color="red darker-4"
                        @click="filerepoform = false"
                    >
                        Close
                    </v-btn>

                    <v-btn
                        dark
                        color="green darker-4"
                        @click="SaveChanges"
                    >
                        Save Changes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="areyousureform"
            scrollable
            max-width="480"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-exclamation-thick mr-2"></i>Confirm Deletion</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-row dense>
                        <v-col
                            cols="12"
                        >
                            <div class="text-h6">Are you sure you want to delete this file?</div>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        dark
                        color="red darker-4"
                        @click="areyousureform = false"
                    >
                        Close
                    </v-btn>

                    <v-btn
                        dark
                        color="green darker-4"
                        @click="DeleteConfirmed"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from "axios"
import _ from 'lodash'

export default {
    name: 'filerepo',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - File Management',
    },
    components: {
        vueDropzone: vue2Dropzone
    },
    data() {
        return {
            filerepoform: false,
            showSnackbar: false,
            snackbarVariant: 'red darken-3',
            modalMessage: '',
            overlay: false,
            filerepo: {
                _id: '',
                filename: '',
                description: '',
            },
            dropzoneexposed: false,
            dropzoneOptions: {
                url: ``,
                uploadMultiple: false,
                acceptedFiles: 'image/png, image/jpeg, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.oasis.opendocument.presentation, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                thumbnailWidth: 150,
                maxFilesize: 10,
                addRemoveLinks: true,
                dictDefaultMessage: "<i class='mdi mdi-cloud-upload-outline mr-2 text-h1'></i>"
            },
            dropzoneimages: [],
            CRM_Interval: null,
            citizen: {},
            options: {},
            filerepos: {
                loading: false,
                total: 0,
                items: [],
                headers: [
                    {
                        text: 'File Name',
                        sortable: false,
                        value: 'filename',
                        align: 'center',
                    },
                    {
                        text: 'Description',
                        sortable: false,
                        value: 'description',
                        align: 'center',
                    },
                    {
                        text: 'Actions',
                        sortable: false,
                        value: 'actions',
                        align: 'center',
                    },
                ],
                roomajax: null
            },
            areyousureform: false,
            todeleteid: '',
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
                    .then(data => {
                        this.filerepos.items = data.items
                        this.filerepos.total = parseInt(data.total)
                    })
            },
            deep: true,
        },
    },
    methods: {
        AddNew() {
            this.filerepoform = true

            this.EmptyForm()
        },
        Download(item) {
            window.location = `${this.domain}/${this.citizen._id.toString()}/${item._id.toString()}/crm_user_filerepo_download`
        },
        DeleteConfirmed() {
            this.overlay = true
            this.areyousureform = false

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_filerepo_delete`,
                data: {
                    _id: this.todeleteid,
                    userid: this.citizen._id.toString()
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        if(this.filerepo._id.toString() == this.todeleteid.toString()){
                            this.EmptyForm()
                        }
                        this.Search()

                        this.showSnackbar = true
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = `File has been uploaded`
                    } else{
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch(() => {
                    this.overlay = false

                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = `Something went wrong.. Try Again Later..`
                })
        },
        Delete(item) {
            this.todeleteid = item._id.toString()

            this.areyousureform = true
        },
        Edit(item) {
            this.filerepoform = true
            this.EmptyForm()
            this.filerepo = _.cloneDeep(item)
        },
        Search() {
            this.getDataFromApi()
                .then(data => {
                    this.filerepos.items = data.items
                    this.filerepos.total = parseInt(data.total)
                })
        },
        getDataFromApi() {
            this.filerepos.loading = true

            return new Promise((resolve) => {
                const { page, itemsPerPage } = this.options
                const start_row = (parseInt(page) - 1) * parseInt(itemsPerPage)

                if(this.filerepos.roomajax){
                    this.filerepos.roomajax.cancel()
                }

                this.filerepos.roomajax = axios.CancelToken.source()

                axios({
                    url: `${this.domain}/crm_user_filerepo`,
                    method: 'POST',
                    data: {
                        start_row,
                        limit: itemsPerPage,
                        userid: this.citizen._id.toString(),
                    },
                    cancelToken: this.filerepos.roomajax.token
                })
                    .then(response => {
                        this.filerepos.loading = false

                        if(response.data.response){
                            setTimeout(() => {
                                const items = this.$jwt.decode(response.data.items, this.jwtsecret)

                                resolve({
                                    items: items.items,
                                    total: response.data.total
                                })
                            }, 500)
                        } else{
                            setTimeout(() => {
                                resolve({
                                    items: [],
                                    total: 0
                                })
                            }, 500)
                        }
                    }).catch(function(err) {
                        console.log(err)

                        resolve({
                            items: [],
                            total: 0
                        })
                    })
            })
        },
        EmptyForm() {
            this.filerepo = {
                _id: '',
                filename: '',
                description: '',
            }

            setTimeout(() => {
                this.$refs.myVueDropzone.removeAllFiles()
            }, 500)
        },
        async SaveChanges() {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            this.dropzoneimages = []

            for await (const file of this.$refs.myVueDropzone.getAcceptedFiles()) {
                toBase64(file).then(mfile => {
                    this.dropzoneimages.push(mfile)
                }).catch(() => {})
            }

            setTimeout(() => {
                if(this.filerepo._id.toString().length == 0 && this.dropzoneimages.length == 0){
                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = `Select a File to upload`

                    return false
                }

                let data = _.cloneDeep(this.filerepo)
                data.dataurl = this.dropzoneimages[0] || ''
                data.userid = this.citizen._id.toString()
                // data.dataurl = data.dataurl.substr(data.dataurl.indexOf(';base64,') + 8)

                // console.log(data)

                this.overlay = true
            
                axios({
                    method: 'post',
                    url: `${this.domain}/crm_user_filerepo_process`,
                    data
                })
                    .then(response => {
                        this.overlay = false

                        if(response.data.response){
                            this.EmptyForm()
                            this.Search()

                            this.showSnackbar = true
                            this.snackbarVariant = 'green darken-3'
                            this.modalMessage = `File has been uploaded`
                        } else{
                            this.showSnackbar = true
                            this.snackbarVariant = 'red darken-3'
                            this.modalMessage = response.data.message
                        }
                    })
                    .catch(() => {
                        this.overlay = false

                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = `Something went wrong.. Try Again Later..`
                    })
            }, 500)
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.dropzoneOptions.url = `${this.domain}/uploadfiles`
        this.dropzoneexposed = true

        this.Search()
    }
}
</script>